import React from "react";
import { Box, Flex, Text, Heading } from "@chakra-ui/react";
import { MOOD_EMOJI_MAP, MOOD_COLOR_MAP } from "utils/data/options";
import { getDateFromStr } from "utils/dynDateUtils";

const DiaryCard = ({ diary }) => {
  const emoji = MOOD_EMOJI_MAP[diary.mood] || "📝";
  const bgColor = MOOD_COLOR_MAP[diary.mood] || "gray.50";

  return (
    <Box
      bg={bgColor}
      borderRadius="lg"
      p={4}
      boxShadow="md"
      _hover={{ boxShadow: "lg", cursor: "pointer" }}
      transition="box-shadow 0.2s"
    >
      <Flex align="center" gap={2} color="gray.700" fontSize="sm">
        <Text fontSize="xl">{emoji}</Text>
        <Text>{getDateFromStr(diary.diaryDate)}</Text>
      </Flex>

      <Heading size="md" mt={2} isTruncated>
        {diary.title}
      </Heading>

      <Text mt={1} noOfLines={1} color="gray.800">
        {diary.content}
      </Text>
    </Box>
  );
};

export default DiaryCard;
